<nav ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
  <ng-container ngbNavItem>
    <a ngbNavLink>{{ 'Main grid' | translate }} </a>
    <ng-template ngbNavContent>
        <qm-neve-measurements-table [valmetDnaTags]="mainNetworkTags"></qm-neve-measurements-table>
    </ng-template>
  </ng-container>
  <ng-container ngbNavItem>
    <a ngbNavLink>{{ 'Auxiliary grid' | translate }} </a>
    <ng-template ngbNavContent>
        <qm-neve-measurements-table [valmetDnaTags]="auxiliaryNetworkTags"></qm-neve-measurements-table>
    </ng-template>
  </ng-container>
</nav>

<div [ngbNavOutlet]="nav" class="mt-2">

</div>
